import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Button from 'Components/UI/Button';

const styles = theme => ({
  root: {},
  hasActionButton: {
    paddingRight: theme.spacing(5),
  },
});

const PlanPassedVerification = ({
  className,
  classes,
  onClick,
  hasActionButton,
}) => {
  return (
    <Button
      className={classNames(classes.root, className, {
        [classes.hasActionButton]: hasActionButton,
      })}
      onClick={onClick}
      variant={'contained'}
      size={'medium'}
      color={'primary'}
      round
      disableElevation
      test={'plan-passed-verification-button'}
    >
      {'Plan passed verification'}
    </Button>
  );
};

PlanPassedVerification.defaultProps = {
  className: '',
  hasActionButton: false,
  onClick: null,
};

PlanPassedVerification.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  hasActionButton: PropTypes.bool,
};

export default withStyles(styles)(PlanPassedVerification);
